export default __webpack_public_path__ + "static/media/junk.e1ce9b76.jpg";